module.exports = __webpack_public_path__ + "static/img/eu.9b280ad6.svg";